'use strict';
import Swiper from 'swiper/bundle';

export function setSwiper() {
  const swiper_thumb1 = new Swiper(".p-modal__thumb--01", {
    spaceBetween: 10,
    slidesPerView: 5
  });

  const swiper1 = new Swiper(".p-modal__slider--01", {
    thumbs: {
      swiper: swiper_thumb1
    },
  });

  const swiper_thumb2 = new Swiper(".p-modal__thumb--02", {
    spaceBetween: 10,
    slidesPerView: 5
  });

  const swiper2 = new Swiper(".p-modal__slider--02", {
    thumbs: {
      swiper: swiper_thumb2
    },
  });

  const swiper_thumb3 = new Swiper(".p-modal__thumb--03", {
    spaceBetween: 10,
    slidesPerView: 6
  });

  const swiper3 = new Swiper(".p-modal__slider--03", {
    thumbs: {
      swiper: swiper_thumb3
    },
  });

  const swiper_thumb4 = new Swiper(".p-modal__thumb--04", {
    spaceBetween: 10,
    slidesPerView: 6
  });

  const swiper4 = new Swiper(".p-modal__slider--04", {
    thumbs: {
      swiper: swiper_thumb4
    },
  });

  const swiper_thumb5 = new Swiper(".p-modal__thumb--05", {
    spaceBetween: 10,
    slidesPerView: 6
  });

  const swiper5 = new Swiper(".p-modal__slider--05", {
    thumbs: {
      swiper: swiper_thumb5
    },
  });
}
